import styled, { useTheme } from 'styled-components'
import Modal from '@/components/common/modals/Modal'
import { Typo, TypoVariant } from '@/components/common/typography'

interface Cart100DealItemErrorModalProps {
  onClose: () => void
  isShow: boolean
  modalData: {
    title: string
    contents?: string
  }
}

export const CartWelcomeDealItemErrorModal = ({ onClose, isShow, modalData }: Cart100DealItemErrorModalProps) => {
  const { color } = useTheme()

  const handleCloseCancel = () => {
    onClose()
  }

  return (
    <Modal open={isShow}>
      <Modal.Content>
        <Modal.Title>
          <Typo variant={TypoVariant.Heading6Bold}>{modalData.title}</Typo>
        </Modal.Title>
        {modalData.contents && (
          <StyledContentBody>
            <Typo variant={TypoVariant.Body3Regular} color={color.gray700} style={{ whiteSpace: 'pre-wrap' }}>
              {modalData.contents}
            </Typo>
          </StyledContentBody>
        )}
      </Modal.Content>
      <Modal.Footer>
        <ModalButton className="ok" onClick={handleCloseCancel}>
          <Typo variant={TypoVariant.Body1Bold} color={color.grayWhite}>
            확인
          </Typo>
        </ModalButton>
      </Modal.Footer>
    </Modal>
  )
}

const ModalButtonContainer = styled.div`
  display: flex;
  gap: 0.4rem;
`

const ModalButton = styled.button`
  flex: 1;
  border-radius: 0.8rem;
  border: 0.1rem solid;
  padding: 1.3rem 1.6rem;
  cursor: pointer;
  width: 100%;

  &.ok {
    border-color: ${({ theme }) => theme.color.blue500};
    background-color: ${({ theme }) => theme.color.blue500};
  }

  &.cancel {
    border-color: ${({ theme }) => theme.color.gray200};
    background-color: ${({ theme }) => theme.color.grayWhite};
  }
`

const StyledContentBody = styled.div`
  margin-top: 1.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  border-radius: 0.8rem;
  background-color: ${({ theme }) => theme.color.gray50};
`
